export const ACTIVE_HOTEL_ZOOM = 16;
export const DEFAULT_SEARCH_ZOOM = 6;
export const DEFAULT_MAP_POSITION = [37.623082, 55.75254] as [number, number];
